import { ComponentType } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import { BrokerJobStatus } from '../core';

export interface JobStatusMeta {
	label: string;
	color?: 'info' | 'success' | 'error';
	icon: ComponentType<SvgIconProps>;
	spin?: boolean;
}

export const JOB_STATUS_META: Record<BrokerJobStatus, JobStatusMeta> = {
	PENDING: { label: 'Pending', icon: ScheduleIcon },
	RUNNING: { label: 'Running', color: 'info', icon: AutorenewIcon, spin: true },
	SUCCEEDED: { label: 'Succeeded', color: 'success', icon: CheckCircleIcon },
	FAILED: { label: 'Failed', color: 'error', icon: ErrorIcon },
	CANCELLED: { label: 'Cancelled', icon: CancelIcon },
	DISPATCHED: { label: 'Dispatched', color: 'info', icon: AutorenewIcon, spin: true },
	WAITING_DEPS: { label: 'Waiting for Dependencies', color: 'info', icon: ScheduleIcon },
};
